import { useTranslation } from 'react-i18next';
import Sifra from '../../../../../shared/components/Sifra';
import { icons } from '../../../../../shared/icons';
import { formatDateFromDB } from '../../../../../utils/FormatDate';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import GridOptionsPonude from './GridOptionsPonude';

const GridProviderPonude = ({
  data,
  loading,
  handleClickDokument,
  handleClickDokumentKlijenti,
  handleOpenDialog,
  downloadFile,
  handleClickPregledZahteva,
}) => {
  const { t, i18n } = useTranslation();
  const idFirme = localStorage.getItem('idFirme');
  const columns = [
    ...(idFirme === '1'
      ? [
          {
            field: 'id',
            disableExport: true,
            headerName: '',
            width: 70,
            sortable: false,
            filterable: false,
            renderCell: (e) => (
              <GridOptionsPonude
                handleOpenDialog={() => handleOpenDialog(e.row.idDok)}
                downloadFile={() => downloadFile(e.row.name, e.row.id)}
              >
                <button className="header-options">{icons.MENU_ICON}</button>
              </GridOptionsPonude>
            ),
          },
        ]
      : []),
    {
      field: 'ceoBrDok',
      headerName: t('docNumber'),
      width: 200,
      renderCell: (e) => {
        const idFirme = localStorage.getItem('idFirme');

        const handleClick = () => {
          if (idFirme === '1') {
            handleClickDokument(e.row.idDok, e.row.id);
          } else {
            handleClickDokumentKlijenti(e.row);
          }
        };

        return <Sifra displayValue={e.value} onClick={handleClick} />;
      },
    },

    ...(idFirme === '1'
      ? [{ field: 'nazivKupca', headerName: t('client'), width: 250 }]
      : []),
    {
      field: 'datum',
      headerName: t('date'),
      width: 200,
      renderCell: (e) => formatDateFromDB(e.row.datum),
    },

    {
      field: 'status',
      headerName: t('status'),
      width: 200,
    },
    {
      field: 'poDokumentu',
      headerName: t('byDocument'),
      width: 200,
      renderCell: (e) => (
        <Sifra
          displayValue={e.value}
          onClick={() => handleClickPregledZahteva(e.row, e.row.id)}
        />
      ),
    },
    { field: 'nazivMasine', headerName: t('robot/mold'), width: 250 },
    {
      field: 'serijskiBrojMasine',
      headerName: t('serialNumber'),
      width: 250,
    },
    {
      field: 'ukupanIznos',
      headerName: t('totalAmount'),
      width: 150,
      type: 'number',
    },
    { field: 'napomena', headerName: t('note'), width: 300 },
    // { field: 'status', headerName: 'Status zahteva', width: 150 },
    // { field: 'statusMasine', headerName: 'Status mašine', width: 150 },
  ];
  return (
    <div style={{ height: '80vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={loading} />
    </div>
  );
};

export default GridProviderPonude;
